// src/pages/pedidos/ConfigPedidoCad.js
import React, { useState, useEffect } from 'react';

import { useConfigPedido } from '../../contexts/pedidos/ConfigPedidoContext';
import Input from '../../components/input/Input';
import InputCheck from '../../components/input/InputCheck';
import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import { useMessage } from '../../contexts/geral/MessageContext';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { fetchData } from '../../services/Api';
import DestaqueProdutoCad from '../produtos/destaqueProdutos/DestaqueProdutoCad';
import ModalTabs from '../../components/modalForm/ModalTabs';
import ModalActions, { ModalActionButton } from '../../components/modalForm/ModalActions';

const MapaModal = ({ show, onHide, onSelectLocation }) => {
    const [position, setPosition] = useState(null);

    const LocationMarker = () => {
        useMapEvents({
            click(e) {
                setPosition(e.latlng);
                onSelectLocation(e.latlng);
                onHide();
            },
        });

        return position === null ? null : (
            <Marker position={position} />
        );
    };

    if (!show) return null;

    return (
        <ModalContainer show={show} largura='800px' variant="cadastro" onHide={onHide}>
            <ModalHeader title="Selecione a Localização" onHide={onHide} />
            <div style={{ height: '400px' }}>
                <MapContainer center={[-27.77940475752819, -54.23400878906251]} zoom={13} style={{ height: '100%', width: '100%' }}>
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; OpenStreetMap contributors'
                    />
                    <LocationMarker />
                </MapContainer>
            </div>
        </ModalContainer>
    );
};

const ConfigPedidoCad = ({ show, onHide }) => {
    const { configPedido, updateConfigPedido } = useConfigPedido();
    const { showMessage } = useMessage();
    const [config, setConfig] = useState({ previsaoMin: '', telefonePedido: '', latitude: '', longitude: '' });
    const [showMap, setShowMap] = useState(false);
    const [isImporting, setIsImporting] = useState(false);
    const [activeTab, setActiveTab] = useState('geral');
    const [showDestaqueProdutoCad, setShowDestaqueProdutoCad] = useState(false);

    useEffect(() => {
        if (show && configPedido) {
            setConfig(configPedido);
            setActiveTab('geral');
        }
    }, [show, configPedido]);

    const handleSave = async () => {
        // if (!config.previsaoMin) {
        //     showMessage("Informe o tempo de previsão!");
        //     return;
        // }

        try {
            await updateConfigPedido(config);
            onHide();
        } catch (error) {
            console.error("Erro ao salvar configuração:", error);
        }
    };

    const handleLocationSelect = ({ lat, lng }) => {
        setConfig(prev => ({ ...prev, latitude: lat, longitude: lng }));
    };

    const handleIntegerOrBlankChange = (field) => (e) => {
        const value = e.target.value.replace(/\D/g, '');
        setConfig({ ...config, [field]: value === '' ? null : parseInt(value, 10) });
    };

    const handleImportarAnotaAi = async () => {
        try {
            setIsImporting(true);
            const result = await fetchData('/AnotaAi/ImportarCadastroAnotaAi');
            showMessage(result);
            setIsImporting(false);
        } catch (error) {
            console.error("Erro ao buscar configurações de Pedido:", error);
            setIsImporting(false);
        }
    };

    const handleTabChange = (tab) => (e) => {
        e.preventDefault();
        setActiveTab(tab);
    };

    if (!show) return null;

    return (
        <>
            <ModalContainer show={show} variant="cadastro" onHide={onHide}>
                <ModalHeader title="Configuração do Pedido" onHide={onHide} />

                <ModalBody>
                    <form>
                        <ModalTabs >
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'geral' ? 'active' : ''}`}
                                    onClick={handleTabChange('geral')}
                                >
                                    Geral
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'produtos' ? 'active' : ''}`}
                                    onClick={handleTabChange('produtos')}
                                >
                                    Produtos
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'promocoes' ? 'active' : ''}`}
                                    onClick={handleTabChange('promocoes')}
                                >
                                    Promoções
                                </button>
                            </li>
                        </ModalTabs>

                        {activeTab === 'geral' && (
                            <>
                                <div className="input-group mb-3">
                                    <Input
                                        label="Tempo de Preparo (min)"
                                        value={config.previsaoMin || ''}
                                        onChange={(e) => setConfig({ ...config, previsaoMin: parseInt(e.target.value, 10) })}
                                        mask={"99"}
                                    />
                                    <Input
                                        label="Tempo Pedido (horas)"
                                        value={config.tempoPedido ?? ''}
                                        onChange={handleIntegerOrBlankChange('tempoPedido')}
                                    />
                                </div>
                                <div className="input-group mb-3">
                                    <Input
                                        label="Telefone (Somente Números)"
                                        value={config.telefonePedido || ''}
                                        onChange={(e) => setConfig({ ...config, telefonePedido: e.target.value })}
                                    />
                                </div>
                                <div className="input-group mb-3">
                                    <Input
                                        label="Latitude"
                                        value={config.latitude || ''}
                                        onChange={(e) => setConfig({ ...config, latitude: e.target.value })}
                                    />
                                    <Input
                                        label="Longitude"
                                        value={config.longitude || ''}
                                        onChange={(e) => setConfig({ ...config, longitude: e.target.value })}
                                    />
                                </div>

                                <div className="input-group mb-3">
                                    <button type="button" className="btn btn-outline-primary" onClick={() => setShowMap(true)}>
                                        Selecionar Localização no Mapa
                                    </button>
                                    <button type="button" className="btn btn-outline-primary" onClick={handleImportarAnotaAi} disabled={isImporting}>
                                        Importar Dados AnotaAi
                                    </button>
                                </div>

                                <div className="input-group mb-3">
                                    <Input
                                        label="Token AnotaAi"
                                        value={config.tokenAnotaAi || ''}
                                        onChange={(e) => setConfig({ ...config, tokenAnotaAi: e.target.value })}
                                        size={450}
                                    />
                                </div>
                                <InputCheck
                                    id="usarChatBotIA"
                                    label="Usar ChatBot IA"
                                    checked={config.usarChatBotIA}
                                    onChange={(e) => setConfig({ ...config, usarChatBotIA: e.target.checked })}
                                />
                                <InputCheck
                                    id="tempoPreparoAceite"
                                    label="Usar Tempo de Preparo Aceite"
                                    checked={config.tempoPreparoAceite}
                                    onChange={(e) => setConfig({ ...config, tempoPreparoAceite: e.target.checked })}
                                />
                            </>
                        )}

                        {activeTab === 'produtos' && (
                            <>
                                <div className="input-group mb-3">
                                    <Input
                                        label="Mais Vendido Dias"
                                        value={config.maisVendidoDias || ''}
                                        onChange={(e) => setConfig({ ...config, maisVendidoDias: parseInt(e.target.value, 10) })}
                                    />
                                    <Input
                                        label="Mais Vendido Qtde"
                                        value={config.maisVendidoQtde || ''}
                                        onChange={(e) => setConfig({ ...config, maisVendidoQtde: parseInt(e.target.value, 10) })}
                                    />
                                </div>
                                <InputCheck
                                    id="maisVendidoListar"
                                    label="Listar Mais Vendidos"
                                    checked={config.maisVendidoListar}
                                    onChange={(e) => setConfig({ ...config, maisVendidoListar: e.target.checked })}
                                />
                                <div className="input-group mt-3">
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary"
                                        onClick={() => setShowDestaqueProdutoCad(true)}
                                    >
                                        Destacar Produtos
                                    </button>
                                </div>
                            </>
                        )}

                        {activeTab === 'promocoes' && (
                            <>
                                <div className="input-group mb-3">
                                    <Input
                                        label="Desconto App %"
                                        value={config.appDesconto || ''}
                                        onChange={(e) => setConfig({ ...config, appDesconto: parseFloat(e.target.value) })}
                                    />
                                    <Input
                                        label="CashBack %"
                                        value={config.cashBackPercent || ''}
                                        onChange={(e) => setConfig({ ...config, cashBackPercent: parseInt(e.target.value, 10) })}
                                    />
                                    <Input
                                        label="Validade CashBack (dias)"
                                        value={config.cashBackValidade || ''}
                                        onChange={(e) => setConfig({ ...config, cashBackValidade: parseInt(e.target.value, 10) })}
                                    />
                                </div>
                            </>
                        )}
                    </form>
                </ModalBody>

                <ModalFooter>
                    <ModalActions >
                        <ModalActionButton className="btn btn-primary" onClick={handleSave} action="save">
                            Salvar
                        </ModalActionButton>
                    </ModalActions>
                </ModalFooter>
            </ModalContainer>

            <MapaModal
                show={showMap}
                onHide={() => setShowMap(false)}
                onSelectLocation={handleLocationSelect}
            />

            <DestaqueProdutoCad
                show={showDestaqueProdutoCad}
                onHide={() => setShowDestaqueProdutoCad(false)}
            />
        </>
    );
};

export default ConfigPedidoCad;
